"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let QuestionPageDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.questionLoading = false;
    this.questionDatas = null;
    this.selectAnswer = null;
    this.userInput = "";
    this.uploading = false;
  }
  open(data) {
    return __async(this, null, function* () {
      try {
        this.questionDatas = data;
        this.$nextTick(() => {
          this._question_page_dialog.show();
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  uploadQuestion() {
    return __async(this, null, function* () {
      try {
        if (this.selectAnswer === null) {
          return;
        }
        if (this.selectAnswer !== null && this.selectAnswer.optionType === "InputText" && (this.userInput === null || this.userInput === "")) {
          this.$message.error(this.$t("qusetion_page.need_input_text"));
          return;
        }
        this.uploading = true;
        yield API.post(`api://base.auth/api/v1/surveys/${this.questionDatas.guid}/submit`, {
          "questions": [
            {
              "guid": this.questionDatas.questions[0].guid,
              "options": [
                {
                  "guid": this.selectAnswer.guid,
                  "inputText": this.userInput === "" ? "" : this.userInput
                }
              ]
            }
          ]
        });
        this.$message.success(this.$t("qusetion_page.upload_success"));
        yield this.closeDialog();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.uploading = false;
      }
    });
  }
  closeDialog() {
    return __async(this, null, function* () {
      try {
        this._question_page_dialog.hide();
        this.userInput = "";
        this.selectAnswer = null;
        this.questionDatas = null;
        yield API.put(`api://base.local/storages/session/firstQuestionPage`, {
          "message": "flag"
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
};
__decorateClass([
  Ref("question-page-dialog")
], QuestionPageDialog.prototype, "_question_page_dialog", 2);
QuestionPageDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], QuestionPageDialog);
export {
  QuestionPageDialog as default
};
